import { scoreColor, scoreLabel } from "../lib/api";

export const ScoreBar = ({ value, label, testId }) => (
  <div data-testid={testId} className="space-y-1.5">
    <div className="flex items-end justify-between gap-3">
      <span className="overline text-[var(--cc-text-dark-muted)]">{label}</span>
      <span className="font-mono-num text-sm font-semibold text-[var(--cc-text-dark)]">
        {value}
        <span className="text-[var(--cc-text-dark-muted)] text-xs"> /100</span>
        <span className="ml-2 text-[10px] font-normal" style={{ color: scoreColor(value) }}>
          {scoreLabel(value)}
        </span>
      </span>
    </div>
    <div className="score-bar">
      <div
        className="score-bar-fill"
        style={{ width: `${value}%`, background: scoreColor(value) }}
      />
    </div>
  </div>
);

export default function ScoreBreakdown({ scores }) {
  return (
    <div className="space-y-4">
      <ScoreBar value={scores.odds_score} label="Odds" testId="score-odds" />
      <ScoreBar value={scores.value_score} label="Value" testId="score-value" />
      <ScoreBar value={scores.transparency_score} label="Transparency" testId="score-transparency" />
      <ScoreBar value={scores.trust_score} label="Trust" testId="score-trust" />
      <ScoreBar value={scores.urgency_score} label="Urgency" testId="score-urgency" />
    </div>
  );
}
